import React, { useEffect, useState } from "react";
import { FaFileExcel, FaSearch } from "react-icons/fa";
import { Form, InputGroup, Button, Badge, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../constants/Table";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import './orders.css'
import * as XLSX from "xlsx";
import { ORDER_STATUSES } from "../../constants/status";
import StatusBadge from "../../constants/statusBadge";

const Orders = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Statuses");
  const navigate = useNavigate();
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const bookingHeaders = [
    'Order Id',
    'RFQ Reference',
    'Title',
    'Order Date',
    'Delivery Date',
    'Amount',
    'Status',
  ];

  const getOrdersList = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`orders/${userDetails?.id}`);
      setOrderList(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrdersList();
  }, []);

  const handleDetails = (index) => {
    const rfq = orderList[index];
    if(userDetails?.company_type_id === 2){
navigate(`/vendor_order_details/${rfq.id_rfq}`, {
            
    state: { orders: rfq },
  
        });

    }else {
    navigate(`/orderDetails/${rfq.id_rfq}`, {
      state: { rfq },
    });
    }

  };
const statusOptions = Object.values(ORDER_STATUSES).map(
  (s) => s.label
);
const allowedStatusCodes = Object.keys(ORDER_STATUSES).map(Number);

const filteredOrderList = orderList.filter((item) => {
  if (!allowedStatusCodes.includes(Number(item.status))) return false;

  const search = searchTerm.toLowerCase();

  const supplierNames = item.products
    ?.map((p) => p.company)
    .join(" ")
    .toLowerCase();

  const titleMatch = item.title?.toLowerCase().includes(search);
  const rfqMatch = item.rfq_id?.toString().includes(search);
  const supplierMatch = supplierNames.includes(search);

  const searchMatch = titleMatch || rfqMatch || supplierMatch;

  const statusMatch =
    statusFilter === "All Statuses" ||
    ORDER_STATUSES[item.status]?.label === statusFilter;

  return searchMatch && statusMatch;
});

const rfq_Data = filteredOrderList.map((item) => {
  return [
    item.display_order_id,
    item.display_id,
    item.title,
    new Date(item.created).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }),
    new Date(item.delivery_date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }),
    `$${item.total_price?.toLocaleString()}`,
    <StatusBadge status={item.status} type="order" />,
  ];
});

const clearAllFilters = () => {
  setStatusFilter("All Statuses");   
  setSearchTerm("");               
};
const handleExport = () => {
  if (!filteredOrderList.length) {
    toast.warning("No data to export");
    return;
  }

  const exportData = filteredOrderList.map((item) => ({
    "Order Id": item.display_order_id,
    "RFQ Reference": item.display_id,
    "Title": item.title,
    "Order Date": new Date(item.created).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }),
    "Delivery Date": new Date(item.delivery_date).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }),
    "Amount": item.total_price,
    "Status": item.status_name,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  XLSX.writeFile(workbook, "Orders_List.xlsx");
};

  return (
    <div className="rfq-section">
      <div className="rfq-header">
        <h4>Orders</h4>
      </div>

     <div className="orders-topbar d-flex justify-content-between align-items-center">

  <div className="d-flex align-items-center gap-3">

    {/* Search box */}
    <div className="orders-search position-relative">
      <FaSearch className="search-icon" />
      <Form.Control
        type="search"
        placeholder="Search Order..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    {/* Status Dropdown */}
    <div className="orders-filter">
     <DropdownButton
  id="status-filter"
  variant="outline-secondary"
  title={statusFilter === "All Statuses" ? "Select Status" : statusFilter}
>
  <Dropdown.Item onClick={() => setStatusFilter("All Statuses")}>
    All Statuses
  </Dropdown.Item>

  {statusOptions.map((status, index) => (
    <Dropdown.Item
      key={index}
      onClick={() => setStatusFilter(status)}
    >
      {status}
    </Dropdown.Item>
  ))}
</DropdownButton>

    </div>
  <button
   className="btn Button text-white primaryColorText"
    onClick={clearAllFilters}
    style={{background:"#d01c4c"}}
  >
    Clear All
  </button>
  </div>

  <Button variant="outline-success" className="export-btn"
    onClick={handleExport}
  >
       <FaFileExcel size={18} style={{ marginRight: 6 ,color:'green'}} />
   
  </Button>

</div>

<div className="orders-table-wrapper">
  <Table
    headers={bookingHeaders}
    data={rfq_Data}
    pagination={true}
    recordsCount={10}
    Action={handleDetails}
  />
</div>

     
    </div>
    
  );
};

export default Orders;
